// extracted by mini-css-extract-plugin
export var closeButton = "styles-module--closeButton--844c8";
export var container = "styles-module--container--091c9";
export var dialogContainer = "styles-module--dialogContainer--2a119";